import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {ItemRequestDialogData} from '@store/item-requests/item-requests.types';
import {ConfirmationDialog, ConfirmationDialogDefinition} from '@aviary/dialogs/confirmation-dialog/confirmation-dialog.types';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {ItemRequestsSelectors} from '@store/item-requests/item-requests.selectors';
import {MAT_DIALOG_DATA, MatDialogConfig} from '@angular/material/dialog';
import {TruncateDirective} from '@aviary/directives/truncate.directive';
import {ConfirmationDialogComponent} from '@aviary/dialogs/confirmation-dialog/confirmation-dialog.component';
import {MEDIUM_DIALOG_CONFIG} from '@aviary/dialogs/base-dialog/base-dialog.types';

@Component({
  selector: 'px-cancel-item-request-dialog',
  template: `
    @let hasLinkedRecord = selectors.hasLinkedCatalogRecordFor(itemRequest) | select;
    <mx-confirmation-dialog [definition]="dialogDefinition">
      <div>
        <p mxTruncate [mxTruncateMaxLines]="2" class="text-title-large">
          @if (hasLinkedRecord) {
            {{ selectors.linkedCatalogRecordTitleFor(itemRequest) | select }}
          } @else {
            {{ selectors.titleFor(itemRequest) | select }}
          }
        </p>
        <p mxTruncate class="text-body-large">
          @if (hasLinkedRecord) {
            {{ selectors.linkedCatalogRecordAuthorFor(itemRequest) | select }}
          } @else {
            {{ selectors.authorFor(itemRequest) | select }}
          }
        </p>
      </div>
    </mx-confirmation-dialog>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, SelectPipe, TruncateDirective, ConfirmationDialogComponent]
})
export class CancelItemRequestDialog implements ConfirmationDialog<ItemRequestDialogData> {
  public readonly dialogData: ItemRequestDialogData = inject(MAT_DIALOG_DATA);
  public readonly itemRequest = this.dialogData.itemRequest;
  public readonly selectors = ItemRequestsSelectors.Stateless;
  public static readonly dialogConfigOverrides: MatDialogConfig = {...MEDIUM_DIALOG_CONFIG, minHeight: 'auto'};

  public readonly dialogDefinition: ConfirmationDialogDefinition = {
    title: 'Cancel Item Request',
    description: 'Canceling this item is not a reversible action. Once it is canceled it cannot be recovered.',
    prompt: 'Are you sure you want to cancel your request for this item?',
    confirmButtonLabel: 'Yes, Cancel',
    cancelButtonLabel: 'Go Back'
  };
}
